import React, { useEffect } from "react";
import Head from "next/head";
import { giftCardReviews } from "~/constants/reviews";
import { GiftCardPage } from "../../views/GiftCardPage";
import { facebook } from "~/settings";
import Router from "next/router";
import axios from "~/config/axios";

export default function GiftCardPageWrapper({ reviews, courses }) {
  useEffect(() => {
    let dataTrack = {
      event: "Gift Card",
      name: "Gift Card",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
  }, []);

  // Metadata
  function renderMetadata() {
    const meta = {
      title:
        "Discover London's favourite courses, classes and workshops. Be it cooking, sushi-making, photography, pottery, baking, floristry or whatever else your heart desires.",
      desc:
        "Get a friend or loved one a gift card for any class, course or workshop in London.",
      image: "https://obby.co.uk/static/images/gift-cards/GiftCard.png",
      url: "https://obby.co.uk/gift"
    };

    const data = {
      "@context": "http://schema.org/",
      "@type": "Webpage",
      name: "Obby - Gift Card",
      description:
        "Get a friend or loved one a gift card for any class, course or workshop in London.",
      image: meta.image,
      url: meta.url,
      primaryImageOfPage: {
        "@type": "ImageObject",
        caption: "Obby - Gift Card",
        author: "Obby",
        contentLocation: "London, UK",
        contentUrl: meta.image,
        description: "Obby - Gift Card",
        name: "Obby - Gift Card"
      }
    };

    return (
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.desc} />
        <meta property="fb:app_id" content={facebook.appId} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.desc} />
        <meta property="og:url" content={meta.url} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:image:width" content="546" />
        <meta property="og:image:height" content="327" />
        <meta property="og:site_name" content="Obby" />
        <meta property="twitter:title" content={meta.title} />
        <meta property="twitter:description" content={meta.desc} />
        <meta property="twitter:card" content="summary" />
        <meta property="twitter:image" content={meta.image} />
        <meta property="twitter:image:alt" content={meta.title} />
        <link rel="canonical" href={meta.url} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: `${JSON.stringify(data)}` }}
        />
      </Head>
    );
  }

  function onSendGiftCard() {
    Router.push("/gift/send");
  }

  function onDiscoverCard() {
    Router.push("/learn");
  }

  function onRedeemGiftCard() {
    Router.push("/redeem");
  }

  return (
    <div>
      {renderMetadata()}
      <GiftCardPage
        onSendGiftCard={onSendGiftCard}
        onViewAllGiftCards={onSendGiftCard}
        onRedeemGiftCard={onRedeemGiftCard}
        onDiscoverCard={onDiscoverCard}
        reviews={reviews}
        courses={courses}
      />
    </div>
  );
}

export async function getServerSideProps() {
  try {
    const response = await axios.get("pages/gift");
    const { reviews, courses } = response.data;
    return {
      props: {
        reviews,
        courses
      }
    };
  } catch (error) {
    throw error;
  }
}
